var map = {
	"./bialystok/index/section-2_pl.mdx": [
		98350,
		98350
	],
	"./bydgoszcz/index/section-2_pl.mdx": [
		5769,
		5769
	],
	"./czestochowa/index/section-2_pl.mdx": [
		55460,
		55460
	],
	"./garwolin/index/section-2_pl.mdx": [
		44687,
		44687
	],
	"./gdansk/index/section-2_pl.mdx": [
		26526,
		26526
	],
	"./gdynia/index/section-2_pl.mdx": [
		9374,
		9374
	],
	"./gliwice/index/section-2_pl.mdx": [
		72790,
		72790
	],
	"./gmina-swidnica/index/section-2_pl.mdx": [
		5475,
		5475
	],
	"./kielce/index/section-2_pl.mdx": [
		12533,
		12533
	],
	"./kolobrzeg/index/section-2_pl.mdx": [
		15879,
		15879
	],
	"./konskowola/index/section-2_pl.mdx": [
		25358,
		25358
	],
	"./koszalin/index/section-2_pl.mdx": [
		33597,
		33597
	],
	"./lask/index/section-2_pl.mdx": [
		32977,
		32977
	],
	"./lodz/index/section-2_pl.mdx": [
		39507,
		39507
	],
	"./lublin/index/section-2_pl.mdx": [
		30542,
		30542
	],
	"./miejsce-piastowe/index/section-2_pl.mdx": [
		6119,
		6119
	],
	"./mikolow/index/section-2_pl.mdx": [
		62750,
		62750
	],
	"./naklo/index/section-2_pl.mdx": [
		37903,
		37903
	],
	"./oborniki/index/section-2_pl.mdx": [
		57117,
		57117
	],
	"./olesnica/index/section-2_pl.mdx": [
		21142,
		21142
	],
	"./postomino/index/section-2_pl.mdx": [
		54362,
		54362
	],
	"./poznan/index/section-2_pl.mdx": [
		49186,
		49186
	],
	"./przechlewo/index/section-2_pl.mdx": [
		14717,
		14717
	],
	"./radom/index/section-2_pl.mdx": [
		14671,
		14671
	],
	"./raszkow/index/section-2_pl.mdx": [
		16163,
		16163
	],
	"./rawicz/index/section-2_pl.mdx": [
		47312,
		47312
	],
	"./ryman/index/section-2_pl.mdx": [
		3611,
		3611
	],
	"./sierakowice/index/section-2_pl.mdx": [
		68100,
		68100
	],
	"./slawno/index/section-2_pl.mdx": [
		90300,
		90300
	],
	"./slawoborze/index/section-2_pl.mdx": [
		72610,
		72610
	],
	"./stare-babice/index/section-2_pl.mdx": [
		49938,
		49938
	],
	"./szczecin/index/section-2_pl.mdx": [
		32579,
		32579
	],
	"./szemud/index/section-2_pl.mdx": [
		97994,
		97994
	],
	"./warszawa/index/section-2_pl.mdx": [
		56094,
		56094
	],
	"./wloszczowa/index/section-2_pl.mdx": [
		58057,
		58057
	],
	"./wroclaw/index/section-2_pl.mdx": [
		88393,
		88393
	],
	"./wyszkow/index/section-2_pl.mdx": [
		58232,
		58232
	],
	"./zukowo/index/section-2_pl.mdx": [
		69965,
		69965
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 34909;
module.exports = webpackAsyncContext;